/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

export const groupData=[
    {
        id: "sg-001",
        title:"Group's name",
        des: "Group's description"
    },
    {
        id: "sg-002",
        title:"Group's name",
        des: "Group's description"
    },
    {
        id: "sg-003",
        title:"Group's name",
        des: "Group's description"
    },
    {
        id: "sg-004",
        title:"Group's name",
        des: "Group's description"
    }
]